import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Application, ApplicationState, Vacancy } from './types';

export const FETCH_VACANCY = 'FETCH_VACANCY';
export const FETCH_VACANCY_SUCCESS = 'FETCH_VACANCY_SUCCESS';
export const ACCEPT_APPLICATION = 'ACCEPT_APPLICATION';
export const ACCEPT_APPLICATION_SUCCESS = 'ACCEPT_APPLICATION_SUCCESS';
export const REJECT_APPLICATION = 'REJECT_APPLICATION';
export const REJECT_APPLICATION_SUCCESS = 'REJECT_APPLICATION_SUCCESS';
export const NEW_HIRING_MANAGER_VIDEO = 'NEW_HIRING_MANAGER_VIDEO';
export const NEW_HIRING_MANAGER_VIDEO_SUCCESS = 'NEW_HIRING_MANAGER_VIDEO_SUCCESS';

export type HiringManagerAction = FetchApplicationSuccess | AxiosResponseAction;

export interface AxiosRequestAction {
    type: typeof ACCEPT_APPLICATION | typeof REJECT_APPLICATION | typeof NEW_HIRING_MANAGER_VIDEO;
    payload: {
        request: AxiosRequestConfig;
    };
}

export interface AxiosResponseAction {
    type:
        | typeof ACCEPT_APPLICATION_SUCCESS
        | typeof REJECT_APPLICATION_SUCCESS
        | typeof NEW_HIRING_MANAGER_VIDEO_SUCCESS;
    payload: AxiosResponse;
    meta: {
        previousAction: any;
    };
}

export interface FetchVacancyAction {
    type: typeof FETCH_VACANCY;
    payload: {
        request: AxiosRequestConfig;
    };
}

export interface FetchApplicationSuccess {
    type: typeof FETCH_VACANCY_SUCCESS;
    payload: AxiosResponse;
}

export const fetchVacancy = (vacancyId: string): FetchVacancyAction => {
    const fetchApplicationAction: FetchVacancyAction = {
        type: FETCH_VACANCY,
        payload: {
            request: {
                url: `/hiring-manager/vacancies/${vacancyId}`
            }
        }
    };
    return fetchApplicationAction;
};

export const acceptApplication = (application: Application): AxiosRequestAction => {
    const url = application._links === undefined ? '' : application._links.self.href;
    return {
        type: ACCEPT_APPLICATION,
        payload: {
            request: {
                url,
                method: 'put',
                data: {
                    id: application.id,
                    applicationState: ApplicationState.APPLICATION_ACCEPTED,
                    hiringManagerNotes: application.hiringManagerNotes
                }
            }
        }
    };
};

export const rejectApplication = (application: Application): AxiosRequestAction => {
    const url = application._links === undefined ? '' : application._links.self.href;
    return {
        type: REJECT_APPLICATION,
        payload: {
            request: {
                url,
                method: 'put',
                data: {
                    id: application.id,
                    applicationState: ApplicationState.APPLICATION_REJECTED,
                    hiringManagerNotes: application.hiringManagerNotes
                }
            }
        }
    };
};

export const newHiringManagerVideo = (vacancy: Vacancy, videoReference: string): AxiosRequestAction => {
    return {
        type: NEW_HIRING_MANAGER_VIDEO,
        payload: {
            request: {
                url: vacancy._links!.self.href,
                method: 'put',
                data: {
                    ...vacancy,
                    hiringManagerVideoReference: videoReference
                }
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/scenes/hiring-manager/actions.ts